import { render, staticRenderFns } from "./ItemsSaleOrder.vue?vue&type=template&id=2c1115dc&"
import script from "./ItemsSaleOrder.vue?vue&type=script&lang=js&"
export * from "./ItemsSaleOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports